import React from 'react';

import PropTypes from 'prop-types';

export default function ComponentGrouper(props) {
  const { components } = props;
  return (
    <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
      {
        components.map((component, index) => {
          const GroupedComponent=component.component;
          return(
            <GroupedComponent key={"gc"+index} {...component.props}/>
          );
        })
      }
    </div>
  );
}

ComponentGrouper.propTypes = {
  components: PropTypes.array.isRequired,
};

ComponentGrouper.defaultProps = {
};
